import type { CSSProperties, ReactNode, Ref } from 'react';

import HandlerIcon from '@/assets/icons/HandlerIcon';

import DashboardCardStyles from '../styles/DashboardCardStyles';

const { StyledDragArea, StyledDashboardCard, StyledDashboardCardWrapper } =
  DashboardCardStyles;

type DashboardCardShellProps = {
  width: string;
  isDragging: boolean;
  previewRef?: Ref<HTMLDivElement>;
  dragRef?: Ref<HTMLDivElement>;
  wrapperStyle?: CSSProperties;
  wrapperClassName?: string;
  cardClassName?: string;
  cardAttributes?: Record<string, string>;
  children: ReactNode;
};

const DashboardCardShell = ({
  width,
  isDragging,
  previewRef,
  dragRef,
  wrapperStyle,
  wrapperClassName,
  cardClassName = 'h-full',
  cardAttributes,
  children,
}: DashboardCardShellProps) => {
  return (
    <StyledDashboardCardWrapper
      ref={previewRef}
      isDragging={isDragging}
      width={width}
      className={wrapperClassName}
      style={wrapperStyle}
    >
      <StyledDashboardCard {...cardAttributes} className={cardClassName}>
        <StyledDragArea ref={dragRef} className="drag-area-handler">
          <HandlerIcon />
        </StyledDragArea>
        {children}
      </StyledDashboardCard>
    </StyledDashboardCardWrapper>
  );
};

export default DashboardCardShell;
